import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import { deleteData, fetchData } from '../../shared/api/api'
import {
  DeleteDossierResponse,
  DeleteDossierRequest,
  FetchDossierResponse,
} from './types'

export const deleteDossier = createAsyncThunk<
  DeleteDossierResponse,
  DeleteDossierRequest,
  { state: RootState }
>('dossier/deleteDossier', async (dossierId, thunkAPI) => {
  const state = thunkAPI.getState()
  const userId = state.user?.profile?.uid

  if (!userId) {
    return thunkAPI.rejectWithValue('Missing userId or dossierId')
  }

  try {
    const response = await deleteData<DeleteDossierResponse>(
      `/users/${userId}/dossiers/${dossierId}`
    )
    console.log(response)

    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error || error.message || 'Unknown error'
    )
  }
})

export const fetchActiveDossier = createAsyncThunk<
  FetchDossierResponse,
  void,
  { state: RootState }
>('dossier/fetchActive', async (_, thunkAPI) => {
  console.log('❗ATTEMPT to get active dossier')
  const state = thunkAPI.getState()
  const userId = state.user?.profile?.uid

  if (!userId) {
    return thunkAPI.rejectWithValue('Missing userId')
  }

  try {
    const response = await fetchData<FetchDossierResponse>(
      `/users/${userId}/getActiveDossier`
    )
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error || error.message || 'Unknown error'
    )
  }
})
